import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import { IScriptDTO } from "../.././store/models/script-manager/script";
import { getTenantId } from "../helper";
let script = /** @class */ (() => {
    var _a, _b, _c, _d;
    let script = class script extends VuexModule {
        constructor() {
            super(...arguments);
            this.cSharpScript = { script: "" };
            this.apiNode = "appscript";
        }
        async GetCSharpScript(moduleId) {
            var url = `${getTenantId()}/${this.apiNode}/csharp/` + moduleId;
            let { data } = await service.get(url);
            if (data) {
                this.SetScripts(data.scripts);
            }
            return null;
        }
        async GetSqlScript(moduleId) {
            var url = `${getTenantId()}/${this.apiNode}/sql/` + moduleId;
            let { data } = await service.get(url);
            if (data) {
                this.SetScripts(data.scripts);
            }
            return null;
        }
        async GetTsScript(moduleId) {
            var url = `${getTenantId()}/${this.apiNode}/ts/` + moduleId;
            let { data } = await service.get(url);
            if (data) {
                this.SetScripts(data.scripts);
            }
            return null;
        }
        SetScripts(script) {
            this.cSharpScript = script;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], script.prototype, "GetCSharpScript", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], script.prototype, "GetSqlScript", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], script.prototype, "GetTsScript", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof IScriptDTO !== "undefined" && IScriptDTO) === "function" ? _d : Object]),
        __metadata("design:returntype", void 0)
    ], script.prototype, "SetScripts", null);
    script = __decorate([
        Module({ dynamic: true, store: store, name: "script", namespaced: true })
    ], script);
    return script;
})();
export const ScriptModule = getModule(script);
